import { css } from '@emotion/react'
import { Theme } from '@mui/material'

export const propertySearchbarContainer = (showSuggestions: boolean, size: string) => css`
  height: ${size == 'small' ? '36px' : '44px'};
  width: ${size == 'small' ? '244px' : '376px'};
  max-width: 100%;
  position: relative;
  margin-bottom: ${showSuggestions ? '24px' : '0px'};
  transition: margin-bottom 0.3s;
`

export const suggestionsDropdown = ({
  theme,
  showSuggestions,
  size,
}: {
  theme: Theme
  showSuggestions: boolean
  size: string
}) => css`
  width: 100%;
  max-height: 200px;
  position: absolute;
  top: ${size == 'small' ? '34px' : '42px'};
  border-radius: 0 0 4px 4px;
  left: 0;
  z-index: 100;
  transition:
    opacity 0.1s,
    transform 0.1s;
  opacity: ${showSuggestions ? 1 : 0};
  transform: ${showSuggestions ? 'translateY(0)' : 'translateY(-8px)'};
  pointer-events: ${showSuggestions ? 'auto' : 'none'};
  user-select: none;
  background: ${theme.palette.background.paper};
  text-align: left;
  overflow: hidden;
  overflow-y: auto;
  box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.25);
`

export const searchIcon = (theme: Theme) => css`
  height: 20px;
  width: 20px;
  fill: ${theme.palette.grey[600]};
`

export const closeButton = (theme: Theme, shown: boolean) => css`
  height: 20px;
  width: 20px;
  fill: ${theme.palette.grey[600]};
  cursor: pointer;
  opacity: ${shown ? 1 : 0};
  transition: opacity 0.1s;
  pointer-events: ${shown ? 'auto' : 'none'};

  &:hover {
    fill: ${theme.palette.grey[900]};
  }
`

export const suggestionsColumn = ({
  theme,
  showSuggestions,
  loading,
}: {
  theme: Theme
  showSuggestions: boolean
  loading: boolean
}) => css`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${theme.palette.background.paper};
  opacity: ${!loading && showSuggestions ? 1 : 0.2};
  transition: opacity 0.1s;
  border-radius: 0 0 4px 4px;
`

export const suggestionsPlaceholder = ({ theme }: { theme: Theme }) => css`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  color: ${theme.palette.grey[500]};
  font-size: 14px;
  line-height: 24px;
  padding: 8px 24px;
`
